module.exports = __webpack_public_path__ + "static/media/MHRP09N0018.d1fd9ac7.svg";